<template>
    <v-main class="ml-6 mt-3">
        <v-row dense>
            <v-col cols="12"><h3>Overview accommodations<span class="ml-2">{{ this.title }}</span></h3>
            </v-col>
        </v-row>
        <v-row v-if="filter==='all'">
            <v-col cols="12">
                <v-card flat class="mr-2">
                    <v-row>
                        <v-col cols="2" class="ml-3">
                            <select_parc @getSelection="setFilter"/>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <acco_table :items="filteredAccos" :table_height="filter==='all' ? wInnerHeight-216 : wInnerHeight-152">
                     <template v-slot:parkbutton="parkbuttonProps">
                        <div style="width:100% !important;">
                            <v-btn small color="warning" class="parkbutton" @click="disconnectDialog(parkbuttonProps)">disconnect</v-btn>
                        </div>
                     </template>
                </acco_table>
            </v-col>
        </v-row>
        <navBar title="Ares - Purchase partners" :home="true" type="pp"/>
        <standard_dialog ref="std_dialog" />
        <confirm_disconnect ref="disconnect" @disconnect="disconnectAcco" />
    </v-main>
</template>

<script>

import navBar from "@/components/ui/navbars/navbar.vue";
import standard_dialog from '@/components/ui/standard_dialog.vue';
import acco_table from '@/components/huis/tables/searchHuisTable.vue';
import select_parc from '@/components/ui/selectors/select_parc.vue';
import mxscreensize from '@/components/js/screensize';
import confirm_disconnect from '@/views/task/pp/confirm_disconnect.vue'

export default {
    props:{
        filter: String,
    },
    components: {
        navBar,
        acco_table,
        select_parc,
        standard_dialog,
        confirm_disconnect,
    },
    mixins: [mxscreensize],
    data() {
        return {
            accos: [],
            cfilter: this.filter,
            title: ''
        }
    },
    computed:{
        filteredAccos: function () {
            return this.accos.filter((acco) => {
                if(this.cfilter !== '' && this.cfilter !== 'all'){
                    return (acco.park_code === this.cfilter)
                } else {
                    return true;
                }
            })            
        }
    },    
    created() {
        this.getAccoInfo('')
    },
    methods: {
        disconnectDialog(data){
            console.log(data)
            this.$refs.disconnect.open(data);
        },
        disconnectAcco(data){
            console.log('do something with', data.param)
            this.$axios
                .post("ares/json/ares/task/pp/disconnectAccoFromParkv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "disconnectAcco"
                    },
                    disconnectAcco: {
                        encrid: data.param
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message)
                    } else {
                        this.getAccoInfo()
                    }
                })

        },
        getAccoInfo() {
            this.$axios
                .post("ares/json/ares/task/pp/getAccoInfov2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getAccoInfo"
                    },
                    getAccoInfo: {
                        filter: this.filter,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        this.accos = res.data.getAccoInfo.info;
                        if(this.filter !=='all'){
                            this.title=this.filteredAccos[0].park_naam;
                        }
                    }
                })
        },      
        setFilter(v){
            this.cfilter=v;
        },  
        showDialog(type, caption, message) {
            this.$refs.std_dialog.open(type, caption, message);
        },  
    }    
}

</script>

<style scoped>
.parkbutton{
    width: 100% !important;
    margin-top: 4px !important;
    margin-bottom: 6px !important;
}
</style>